import { CompanyRegistrationDto } from '../../../../api';

export const StateFilterEnum = {
    NONE: 'none',
    ...CompanyRegistrationDto.registrationState,
};
